module.exports = __webpack_public_path__ + "static/media/sidebar-schedule.2bfb3bec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-schedule.svg
// module id = 801
// module chunks = 0